module.exports = __webpack_public_path__ + "images/icons/icon-large-right-arrow-b10994ee.svg";